import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Individual, IndividualRequest, Pageable, Recipient} from 'src/app/models';
import { Cacheable } from 'ts-cacheable';


@Injectable({
    providedIn: 'root'
})
export class IndividualsService {
    url = '/api/v1/recipients';

    constructor(public http: HttpClient) {
    }

    getIndividuals(val: string): Observable<Individual[]> {
        val = encodeURIComponent(val);
        return this.http.get<Individual[]>(`/api/v1/individuals?identifier=${val}`)
            .pipe(map(recipients => recipients['content']));
    }

    getIndividualsAndDevices(name: string): Observable<Pageable<Recipient[]>> {
        name = encodeURIComponent(name);
        return this.http.get<Pageable<Recipient[]>>(`/api/v1/recipients?identifier=${name}`);
    }

    getIndividualsAndDevicesPage(name: string, page): Observable<Recipient[]> {
        name = encodeURIComponent(name);
        return this.http.get<Recipient[]>(`/api/v1/recipients?identifier=${name}&size=${page}`)
            .pipe(map(recipients => recipients['content']));
    }
    @Cacheable({
        maxAge: 1800000,
        maxCacheCount: 100,
        async: true
    })
    getIndividual(id): Observable<Individual> {
        return this.http.get<Individual>(`/api/v1/individuals/${id}`);
    }

    createIndividual(request: IndividualRequest): any {
        return this.http.post(`/api/v1/individuals`, request);
    }

    updateIndividual(request: IndividualRequest): any {
        return this.http.put(`/api/v1/individuals`, request);
    }

    deleteIndividual(id: number): Observable<Individual> {
        return this.http.delete<Individual>(`/api/v1/individuals/${id}`);
    }

    hasResponseRequiredContact(id: number): Observable<boolean> {
        return this.http.get<boolean>(`/api/v1/individuals/${id}/has-response-required-contact`);
    }
}
